import { ErrorMessage } from '@hookform/error-message';
import ErrorMessageStyle from 'Components/Form/ErrorMessageStyle';
import Label from 'Components/Form/Label';
import styles from 'Components/Form/RadioInput/RadioInput.module.css';
import { RegisterOptions } from 'react-hook-form';
export interface RadioInputProps extends IRadioFieldBasic {
  rules?: RegisterOptions;
  register?: any;
  labelIcon?: React.ReactNode;
  errors?: any;
  label?: string;
}
export const RadioInputBasic = ({
  name,
  rules,
  options = [
    { label: 'Yes', value: 'yes' },
    { label: 'No', value: 'no' },
  ],
  label,
  labelIcon,
  register,
  errors,
  ...rest
}: RadioInputProps) => {
  return (
    <>
      <Label label={label} labelIcon={labelIcon}>
        <div className="flex gap-4">
          {options.map((option, i) => (
            <label key={i} className={styles.radio_button}>
              <input
                {...register(name)}
                type="radio"
                name={name}
                value={option.value}
                className="custom-form-radio cursor-pointer"
              />

              <span className="ml-5 block text-xs">{option.label}</span>
            </label>
          ))}
        </div>
        {errors && (
          <ErrorMessage
            errors={errors}
            name={name}
            render={({ message }) => <ErrorMessageStyle message={message} />}
          />
        )}
      </Label>
    </>
  );
};
